import React, { memo, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import SkeletonTable from "../../components/Skeleton/SkeletonTable";
import EmptyData from "../../components/image/EmptyData";
import UnreadText from "../../components/common/UnreadText";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin, Avatar, Tabs } from "antd";
import {
  subStringAvatar,
  trimOverLengthString,
} from "../../components/common/CellText";
import { apiUrl } from "../../config";
import { useTheme } from "@mui/material";
import { HiOutlineUser, HiPhone } from "react-icons/hi2";
import { AiFillCaretDown, AiFillCaretUp, AiOutlineMail } from "react-icons/ai";
import authenticationStore from "../../store/authenticationStore";

const { TabPane } = Tabs;

function createData(
  ma_nv,
  username,
  name_lowercase,
  email,
  phone,
  home_phone,
  address,
  position,
  department
) {
  return {
    ma_nv,
    username,
    name_lowercase,
    email,
    phone,
    home_phone,
    address,
    position,
    department,
  };
}

const ListDepartmentContact = (props) => {
  const { loadingAnimationStore, userStore, departmentStore } = props;
  const { departmentList } = departmentStore;
  const { userList, getUserList, userOfDepartmentData } = userStore;
  const location = useLocation();
  const navigate = useNavigate();
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: "index",
  });
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const [rows, setRows] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  useEffect(() => {
    setRows(
      userOfDepartmentData.map((record) =>
        createData(
          <UnreadText text={record.ma_nv} />,
          <UnreadText
            text={
              <div className="flex gap-2 w-[100%] items-center">
                <HiOutlineUser size={20} color={theme.color.primary} />
                <div
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%",
                    color: theme.color.primary,
                  }}
                >
                  {record.username}
                </div>
              </div>
            }
            width={"100%"}
          />,
          <UnreadText
            text={
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "16px",
                  color: theme.color.primary,
                }}
              >
                {record.name_lowercase}
              </span>
            }
          />,
          record.email,
          record.phone,
          record.home_phone,
          record.address,
          <UnreadText
            text={
              <div
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-all",
                  color: theme.color.primary,
                }}
              >
                {record.position?.name}
              </div>
            }
          />,
          <UnreadText
            text={
              <div
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-all",
                  color: theme.color.primary,
                }}
              >
                {record.department?.name}
              </div>
            }
          />
        )
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOfDepartmentData]);
  const [hasMore, setHasMore] = useState(true);
  const fetchMoreData = async () => {
    // if (userList.length >= userStore.userListTotalCount) {
    //   setHasMore(false)
    //   return
    // }
    // userStore.changeUserListPageIndex(userStore.userListPageIndex + 1)
    // try {
    //   await userStore.getUserList()
    // } catch (err) {
    //   console.log(err)
    // }
  };
  const [hasMoreChildren, setHasMoreChildren] = useState(false);
  const fetchMoreDataChildren = async () => {
    if (
      userOfDepartmentData.length >= userStore.userOfDepartmentListTotalCount
    ) {
      setHasMoreChildren(false);
      return;
    }
    userStore.setFilter(
      "userOfDepartmentListPageIndex",
      userStore.userOfDepartmentListPageIndex + 1
    );
    try {
      await userStore.getUserListByDepartment();
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (
      userOfDepartmentData.length < userStore.userOfDepartmentListTotalCount
    ) {
      setHasMore(true);
      return;
    }
  }, []);
  const handleClickPhone = (phone) => {
    window.location.href = `tel:${phone}`;
  };
  const handleClickEmail = (email) => {
    window.location.href = `mailto:${email}`;
  };
  const onChangeTabDepartment = (key) => {
    loadingAnimationStore.showSpinner(true);
    userStore.clearUserOfDepartmentData();
    userStore.setFilter("userOfDepartmentListByDepartmentCode", key);
    userStore.setFilter("userOfDepartmentListPageIndex", 0);
    userStore.setFilter("userOfDepartmentListPageSize", 5);
    userStore
      .getUserListByDepartment()
      .then(() => {
        loadingAnimationStore.showSpinner(false);
      })
      .catch(() => {
        loadingAnimationStore.showSpinner(false);
      });
    setSelectedDepartment(key);
    setHasMoreChildren(true);
  };
  const getAllDepartmentList = async () => {
    try {
      if (authenticationStore.currentUser) {
        await departmentStore
          .getAllDepartmentList(authenticationStore.currentCompanyCode())
          .then((resAllDepartmentList) => {
            userStore.setFilter(
              "userOfDepartmentListByDepartmentCode",
              resAllDepartmentList.data[0].code
            );
          });
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  useEffect(() => {
    (async () => {
      setLoading(true);
      departmentStore.clearDepartmentList();
      await getAllDepartmentList();
      setLoading(false);
    })();
  }, []);
  return (
    <>
      {loading ? (
        <SkeletonTable />
      ) : departmentList?.length > 0 ? (
        <section className="mt-1 overflow-x-auto hideScrollbar pt-2 pb-[30px]">
          <InfiniteScroll
            dataLength={userList.length}
            next={fetchMoreData}
            hasMore={false}
            style={{
              scrollSnapStop: "always",
            }}
            scrollableTarget="infinityScrollableDiv"
            loader={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 10,
                }}
              >
                {userList.length > 10 ? <Spin tip="Đang tải..." /> : ""}
              </div>
            }
          >
            <div className="inline-block w-[100%] overflow-visible hideScrollbar ">
              <div>
                {departmentList.map((department, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#fff",
                      margin: " 5px",
                    }}
                  >
                    <div
                      className="flex items-center  text-[#0073c7] justify-between"
                      onClick={() => {
                        if (selectedDepartment === department.code) {
                          setSelectedDepartment(null);
                        } else {
                          onChangeTabDepartment(department.code);
                        }
                      }}
                    >
                      <div
                        className="flex-grow m-4"
                        style={{ fontSize: 20, fontWeight: "bold" }}
                      >
                        {department?.name}
                      </div>
                      <div className="m-4">
                        {selectedDepartment === department.code ? (
                          <AiFillCaretUp />
                        ) : (
                          <AiFillCaretDown />
                        )}
                      </div>
                    </div>
                    {selectedDepartment === department.code && (
                      <section className="mt-1 overflow-x-auto hideScrollbar pb-[30px] ">
                        <InfiniteScroll
                          dataLength={userOfDepartmentData.length}
                          next={fetchMoreDataChildren}
                          hasMore={hasMoreChildren}
                          style={{
                            scrollSnapStop: "always",
                          }}
                          height={500}
                          scrollableTarget="infinityScrollableDiv"
                          loader={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: 10,
                              }}
                            >
                              {userOfDepartmentData.length > 5 ? (
                                <Spin tip="Đang tải..." />
                              ) : (
                                ""
                              )}
                            </div>
                          }
                        >
                          <div className="inline-block w-[100%] overflow-visible hideScrollbar ">
                            <div>
                              {rows.map((row, index) => (
                                <div
                                  key={index}
                                  style={{
                                    backgroundColor: "#ffffff",
                                    padding: "12px 8px 8px 8px",
                                    margin: " 15px auto",
                                    borderRadius: "10px",
                                    boxShadow:
                                      "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                                  }}
                                >
                                  <div
                                    className="flex items-center"
                                    style={{
                                      fontWeight: "bold",
                                      borderBottom: "1px solid #80808070",
                                      paddingBottom: 15,
                                    }}
                                  >
                                    <div
                                      className="pt-1 "
                                      style={{
                                        width: "12%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Avatar
                                        size={30}
                                        style={{
                                          backgroundColor: "#2C65AC",
                                          fontSize: 12,
                                        }}
                                        src={
                                          userOfDepartmentData[index]
                                            ?.imageId &&
                                          `${apiUrl}/api/v1/images/${userOfDepartmentData[index].imageId}`
                                        }
                                      >
                                        {subStringAvatar(
                                          userOfDepartmentData[index]
                                            ?.name_uppercase
                                        )}
                                      </Avatar>
                                    </div>
                                    <div className="" style={{ width: "88%" }}>
                                      <div className="mr-1 w-[100%]">
                                        {row?.name_lowercase}
                                      </div>
                                      <div className="flex">
                                        <div
                                          className=""
                                          style={{ width: "100px" }}
                                        >
                                          <div className="mr-1">Chức vụ:</div>
                                        </div>
                                        <div
                                          className=""
                                          style={{
                                            width: "calc(100%-100px)",
                                          }}
                                        >
                                          <div className="mr-1">
                                            {row?.position}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="flex">
                                        <div
                                          className=""
                                          style={{ width: "100px" }}
                                        >
                                          <div className="mr-1">Phòng ban:</div>
                                        </div>
                                        <div
                                          className=""
                                          style={{
                                            width: "calc(100%-100px)",
                                          }}
                                        >
                                          <div className="mr-1">
                                            {row?.department}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="flex flex-wrap items-center w-full"
                                    style={{ margin: 5 }}
                                  >
                                    <div
                                      className="mr-3"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "35%",
                                      }}
                                      onClick={() =>
                                        handleClickPhone(row.phone)
                                      }
                                    >
                                      <HiPhone
                                        color={theme.color.gray}
                                        style={{
                                          marginRight: "5px",
                                          flexShrink: 0,
                                        }}
                                      />
                                      {row.phone}
                                    </div>
                                    <div className="flex  items-center">
                                      <AiOutlineMail
                                        style={{
                                          marginRight: "5px",
                                          flexShrink: 0,
                                        }}
                                      />
                                      <div
                                        style={{
                                          whiteSpace: "wrap",
                                          overflowWrap: "break-word",
                                          wordBreak: "break-all",
                                        }}
                                        onClick={() =>
                                          handleClickEmail(row.email)
                                        }
                                      >
                                        {row.email}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </InfiniteScroll>
                      </section>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        </section>
      ) : (
        <EmptyData />
      )}
    </>
  );
};

export default memo(
  inject(
    "loadingAnimationStore",
    "departmentStore",
    "userStore"
  )(observer(ListDepartmentContact))
);
